import React from "react";
import styled from "@emotion/styled";

import mediaqueries from "@styles/media";

import { Icon } from "@types";

const Logo: Icon = ({ fill = "black" }) => {
  return (
    <LogoContainer>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="128pt"
        height="72pt"
        viewBox="0 0 1323.000000 365.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          transform="translate(0.000000,365.000000) scale(0.100000,-0.100000)"
          fill={fill}
          stroke="none"
        >
          <path
            d="M230 2060 l0 -1260 230 0 230 0 0 106 0 107 64 -64 c117 -118 254
-179 416 -187 287 -13 539 111 685 337 89 138 125 264 132 461 6 166 -12 276
-66 415 -92 238 -293 421 -517 471 -120 26 -291 16 -413 -25 -103 -35 -133
-52 -203 -120 l-48 -45 0 532 0 532 -255 0 -255 0 0 -1260z m955 -51 c211 -39
333 -233 298 -474 -32 -224 -203 -353 -437 -330 -242 23 -374 204 -345 475 26
239 228 376 484 329z"
          />
          <path
            d="M2290 2060 l0 -1260 250 0 250 0 0 1260 0 1260 -250 0 -250 0 0
-1260z"
          />
          <path
            d="M12490 2787 l0 -533 -56 54 c-98 95 -227 141 -419 149 -135 6 -233
-12 -339 -62 -287 -136 -476 -522 -436 -895 22 -218 91 -376 220 -510 155
-161 356 -238 589 -227 174 8 315 71 430 191 l51 55 0 -105 0 -104 235 0 235
0 0 1260 0 1260 -255 0 -255 0 0 -533z m-200 -792 c152 -53 240 -195 240 -384
0 -229 -115 -373 -322 -403 -144 -22 -300 27 -374 117 -18 23 -46 68 -61 101
-26 55 -28 68 -28 184 0 116 2 129 28 184 55 118 136 185 257 213 67 15 199 9
260 -12z"
          />
          <path
            d="M3835 2453 c-91 -14 -202 -50 -290 -93 -173 -84 -287 -197 -371 -365
-66 -135 -86 -222 -86 -385 0 -163 20 -250 86 -385 84 -168 198 -281 371 -365
158 -77 237 -94 440 -95 146 0 182 3 254 23 335 91 555 311 627 627 25 107 25
283 0 390 -71 314 -292 536 -622 625 -60 17 -114 23 -229 25 -82 2 -163 1
-180 -2z m240 -444 c127 -23 206 -82 262 -197 38 -76 38 -76 38 -202 0 -126 0
-126 -38 -202 -58 -119 -138 -176 -278 -199 -54 -9 -89 -10 -146 -1 -205 32
-323 179 -323 402 0 283 205 451 485 399z"
          />
          <path
            d="M5692 2440 c-283 -76 -490 -319 -553 -651 -15 -82 -15 -277 0 -354
56 -275 204 -477 426 -581 103 -47 176 -65 305 -71 98 -5 129 -2 200 16 116
29 184 64 252 131 l58 56 0 -112 c0 -274 -120 -408 -388 -430 -164 -13 -326
33 -487 141 l-96 64 -136 -205 -137 -206 34 -29 c19 -16 85 -54 145 -84 170
-85 376 -125 635 -125 519 0 811 210 911 655 22 98 23 113 26 933 l4 832 -235
0 -236 0 0 -101 0 -102 -54 54 c-70 70 -145 114 -254 152 -75 25 -105 30 -217
33 -107 3 -143 1 -203 -16z m495 -460 c85 -39 156 -108 196 -189 30 -61 32
-72 32 -171 0 -99 -2 -110 -32 -171 -41 -83 -111 -150 -201 -192 -60 -28 -77
-31 -157 -31 -80 0 -97 3 -158 31 -84 40 -163 117 -202 198 -27 55 -30 69 -30
165 0 96 3 110 30 165 52 107 169 202 279 225 71 15 174 3 243 -30z"
          />
          <path
            d="M7792 2440 c-283 -76 -490 -319 -553 -651 -15 -82 -15 -277 0 -354
56 -275 204 -477 426 -581 103 -47 176 -65 305 -71 98 -5 129 -2 200 16 116
29 184 64 252 131 l58 56 0 -112 c0 -274 -120 -408 -388 -430 -164 -13 -326
33 -487 141 l-96 64 -136 -205 -137 -206 34 -29 c19 -16 85 -54 145 -84 170
-85 376 -125 635 -125 519 0 811 210 911 655 22 98 23 113 26 933 l4 832 -235
0 -236 0 0 -101 0 -102 -54 54 c-70 70 -145 114 -254 152 -75 25 -105 30 -217
33 -107 3 -143 1 -203 -16z m495 -460 c85 -39 156 -108 196 -189 30 -61 32
-72 32 -171 0 -99 -2 -110 -32 -171 -41 -83 -111 -150 -201 -192 -60 -28 -77
-31 -157 -31 -80 0 -97 3 -158 31 -84 40 -163 117 -202 198 -27 55 -30 69 -30
165 0 96 3 110 30 165 52 107 169 202 279 225 71 15 174 3 243 -30z"
          />
          <path
            d="M10085 2453 c-146 -20 -346 -105 -452 -193 -165 -134 -267 -328 -292
-554 -33 -288 78 -572 292 -746 78 -64 235 -142 347 -172 72 -19 110 -22 250
-22 151 0 172 2 254 28 143 43 255 107 352 199 46 43 82 83 79 87 -7 12 -333
250 -341 250 -4 0 -37 -29 -73 -64 -77 -74 -123 -100 -208 -116 -138 -27 -269
14 -360 113 -45 49 -93 141 -93 177 0 6 215 10 580 10 l580 0 0 95 c0 501
-210 821 -592 899 -72 15 -246 20 -323 9z m242 -387 c52 -26 111 -84 138 -137
9 -17 19 -55 22 -85 l6 -54 -328 0 -328 0 7 41 c19 121 130 232 259 259 70 15
169 4 224 -24z"
          />
        </g>
      </svg>
    </LogoContainer>
  );
};

export default Logo;

const LogoContainer = styled.div`
  .Logo__Mobile {
    display: none;
  }

  ${mediaqueries.tablet`
    .Logo__Desktop {
      display: none;
    }
    
    .Logo__Mobile{
      display: block;
    }
  `}
`;
